import React, { useState, useEffect } from "react";
import "./BackToTopIcon.css";

/**
 * Icon that displays when the user scrolls down the page, allowing them to click it to 
 * smoothly scroll back to the top.
 */
const BackToTopIcon = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 500) {
            // Adjust the value based on your needs
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", toggleVisibility);

        return () => {
            window.removeEventListener("scroll", toggleVisibility);
        };
    }, []);

    return isVisible ? (
        <button
            className="back-to-top-button"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            aria-label="Back to top"
        >
            <span className="back-to-top-text">Back to Top</span>
        </button>
    ) : null;

};

export default BackToTopIcon;